<p *ngIf="isInstallerSuspended" class="suspended-user-info d-flex justify-content-center">
  {{ 'LeadPortal.installer.suspended.notice' | translate }}
</p>
